var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.item ? _c('div', {
    staticClass: "pa-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Item')
    }
  })], 1) : _c('div', [_c('div', {
    style: {
      'min-height': _vm.$size(96) + 16 + 'px'
    }
  }, [_c('div', {
    staticClass: "float-right px-4 hidden-xs-only"
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.townobjecticon.format(_vm.item.m_ResourceID + '00') + '.png',
      "target": "_blank"
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": _vm.$size(96)
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.townobjecticon.format(_vm.item.m_ResourceID + '00') + '.jpg'
    }
  })], 1)], 1)]), _c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.item.m_ObjName))]), _c('div', {
    staticClass: "px-4 hidden-sm-and-up text-center"
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.townobjecticon.format(_vm.item.m_ResourceID + '00') + '.png',
      "target": "_blank"
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": 128
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.townobjecticon.format(_vm.item.m_ResourceID + '00') + '.jpg'
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "pb-4"
  }), _c('p', {
    staticClass: "px-4",
    class: {
      small: _vm.$vuetify.breakpoint.xsOnly
    },
    domProps: {
      "innerHTML": _vm._s(_vm.item.m_DetailText.replace('\n', '<br>'))
    }
  })]), _c('div', {
    staticClass: "px-4 mb-4"
  }, [_vm.item.m_TitleType != -1 ? _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Title'),
      "v": _vm.$name(_vm.$store.state.$db.TitleList[_vm.item.m_TitleType].m_DisplayName),
      "width": "33%"
    }
  }) : _vm._e(), _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Max Num'),
      "v": _vm.item.m_MaxNum,
      "width": "33%"
    }
  })], 1), _c('v-divider'), _c('Ad', {
    key: "townobject-ad-".concat(_vm.id)
  }), _c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "title px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Schedule')))]), _c('v-simple-table', {
    key: "town-object-".concat(_vm.id, "-schedule"),
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(_vm.$t('Character')))]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(_vm.$t('Text')))])])]), _c('tbody', [_vm._l(_vm.schedules, function (schedule) {
          return [_c('tr', {
            key: "town-object-".concat(_vm.id, "-schedule-").concat(schedule.m_ID, "-header")
          }, [_c('th', {
            attrs: {
              "colspan": "2"
            }
          }, [_vm._v(_vm._s(schedule.m_TagName))])]), _c('tr', {
            key: "town-object-".concat(_vm.id, "-schedule-").concat(schedule.m_ID, "-common")
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(_vm.$t('Common')))]), _c('td', {
            staticClass: "text-center",
            domProps: {
              "innerHTML": _vm._s(schedule.m_DisplayName.replace('\n', '<br>'))
            }
          })]), _vm._l(_vm.scheduleReplaces(schedule.m_ID), function (namedTypes, text) {
            return _c('tr', {
              key: "town-object-".concat(_vm.id, "-schedule-").concat(schedule.m_ID, "-").concat(text)
            }, [_c('td', {
              staticClass: "text-center"
            }, _vm._l(namedTypes, function (namedType) {
              return _c('router-link', {
                key: "town-object-".concat(_vm.id, "-schedule-").concat(schedule.m_ID, "-").concat(text, "-").concat(namedType),
                attrs: {
                  "to": "/named/".concat(namedType)
                }
              }, [_c('CharaIcon', {
                attrs: {
                  "named": "",
                  "id": namedType,
                  "size": 48
                }
              })], 1);
            }), 1), _c('td', {
              staticClass: "text-center",
              domProps: {
                "innerHTML": _vm._s(text.replace('\n', '<br>'))
              }
            })]);
          })];
        })], 2)];
      },
      proxy: true
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }